/**
 * CUSTOM HORIZON GLOBAL SCRIPT
 */

document.addEventListener("DOMContentLoaded", function () {
  console.log("Custom Horizon JS loaded");
});

// Helium consultation form styling

(() => {
  const DEFAULT_MIN = 0;
  const DEFAULT_MAX = 10;
  const DEFAULT_STEP = 1;
  const DEFAULT_VALUE = 5;

  function syncValue(formEl, inputEl, value) {
    inputEl.value = value;

    if (formEl.cfForm?.setFieldValue && inputEl.name) {
      try {
        formEl.cfForm.setFieldValue(inputEl.name, value);
      } catch (_) {}
    }

    inputEl.dispatchEvent(new Event("input", { bubbles: true }));
    inputEl.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function updateActiveNotch(fieldEl, value) {
    fieldEl.querySelectorAll(".consultation-slider-notch").forEach((notch) => {
      notch.classList.toggle("is-active", notch.dataset.sliderValue === String(value));
    });
  }

  function enhanceSliderField(formEl, fieldEl) {
    if (fieldEl.dataset.sliderEnhanced === "true") return;

    const inputEl = fieldEl.querySelector('input[type="number"], input[type="text"]');
    if (!inputEl) return;

    const container = fieldEl.closest(".cf-field-container");
    container?.classList.add("cf-field-container--slider");

    const min = inputEl.min || DEFAULT_MIN;
    const max = inputEl.max || DEFAULT_MAX;
    const step = inputEl.step || DEFAULT_STEP;
    const value = inputEl.value || DEFAULT_VALUE;

    inputEl.style.display = "none";

    const range = document.createElement("input");
    range.type = "range";
    range.className = "consultation-slider";
    range.min = String(min);
    range.max = String(max);
    range.step = String(step);
    range.value = String(value);

    range.addEventListener("input", () => {
      syncValue(formEl, inputEl, range.value);
      updateActiveNotch(fieldEl, range.value);
    });
    inputEl.insertAdjacentElement("beforebegin", range);

    if (!fieldEl.querySelector(".consultation-slider-notch")) {
      const minNumber = Number(min);
      const maxNumber = Number(max);
      const stepNumber = Number(step) || DEFAULT_STEP;

      for (let i = minNumber; i <= maxNumber; i += stepNumber) {
        const notch = document.createElement("div");
        notch.className = "consultation-slider-notch";
        notch.dataset.sliderValue = String(i);
        const percent = ((i - minNumber) / (maxNumber - minNumber)) * 100;
        notch.style.left = `${percent}%`;

        fieldEl.appendChild(notch);
      }
    }

    if (!fieldEl.querySelector(".consultation-slider-label")) {
      const start = document.createElement("div");
      start.className = "consultation-slider-label consultation-slider-label--start";
      start.textContent = "Not at all";

      const end = document.createElement("div");
      end.className = "consultation-slider-label consultation-slider-label--end";
      end.textContent = "Extremely";

      fieldEl.append(start, end);
    }

    syncValue(formEl, inputEl, range.value);
    updateActiveNotch(fieldEl, range.value);
    fieldEl.dataset.sliderEnhanced = "true";
  }

  function initForm(formEl) {
    formEl.querySelectorAll(".cf-field.slider-field").forEach((fieldEl) => {
      enhanceSliderField(formEl, fieldEl);
    });

    if (formEl.dataset.sliderBridgeBound === "true") return;
    formEl.addEventListener("cf:step_changed", () => initForm(formEl));
    formEl.dataset.sliderBridgeBound = "true";
  }

  function boot() {
    document.querySelectorAll('form[data-cf-form]').forEach((formEl) => {
      if (formEl.cfForm) initForm(formEl);
    });
  }

  if (window.CF?.ready) {
    window.CF.ready(boot);
  } else {
    document.addEventListener("cf:ready", boot);
    document.addEventListener("DOMContentLoaded", () => window.setTimeout(boot, 300));
  }
})();

// End of custom script
